import Skvllbabiez from '../services/Skvllbabiez';
import Skvllpvnkz from '../services/Skvllpvnkz';

export const fetchCollectionBalance = async (
	collectionContract: Skvllpvnkz | Skvllbabiez,
	address: string
): Promise<number> => collectionContract?.fetchBalanceOfWallet(address);
